
import { Link} from "react-router-dom";
import { PATHS } from '../../paths';
import { useApolloClient } from '@apollo/client';

function LogoutPage() {
  const client = useApolloClient();
  client.clearStore();

  setTimeout(() => {
    window.location.href = PATHS.ROOT;
  }, 1000);

  return (<div>
    Bye, <Link to={PATHS.LOGIN}>Login</Link> again soon.
  </div>);
}

export { LogoutPage };
